import gql from 'graphql-tag';

export default gql`
  mutation DeleteQueryHistoryBulk($input: DeleteQueryHistoryBulkInput!) {
    deleteQueryHistoryBulk(input: $input) {
      deleted
    }
  }
`;
